









































































import {Component, PropSync, Watch} from 'vue-property-decorator';
  import BaseFilter from "@/components/Filter/BaseFilter";
  import {BlacklistFilter} from "@/store/settings/blacklists/types";
  import {SelectWings, InputWings} from "wings-ui-components";
  import {Action, Getter} from "vuex-class";
  import {PartnerUserItem} from "@/store/user_management/partner_users/types";
  import {notifyError} from "@/utils/notify-helper";
  import {getTranslatedParams} from "@/utils/notify-utils";

  @Component({components: {SelectWings, InputWings}})
  export default class BlackListsFilter extends BaseFilter<BlacklistFilter> {
    @PropSync('filterProp') filterParent!: any;
    @PropSync('runFilter') run!: any;
    @PropSync('show') is_show!: boolean;
    @Getter("partnerUsers") partnerUsersList: any;
    @Action("getPartners") actionGetPartners: any;
    @Action("getPartnerUsers") actionGetPartnerUsers: any;
    @Action("getBlacklists") actionGetBlacklists: any;

    defaultFilter(): BlacklistFilter {
      return {
        name: undefined,
        partner: undefined,
        partner_user: undefined,
        is_public: 0,
        page_number: 1
      };
    }

    get partnerUsersForBlackList() {
      return (<PartnerUserItem[]>this.partnerUsersList ?? [])
          .filter(pu => !this.filter.partner || this.filter.partner === pu.partner)
    }

    partnersList: any = []

    async getPartnersList(filter: any) {
      const items = await this.actionGetPartners(filter);
      this.partnersList = (filter?.page_number > 1) ? this.partnersList.concat(items) : items
    }

    async created() {
      this.actionGetPartnerUsers();
      this.filtered();
      this.scroll();
      if (this.filter.partner) this.partnersList = await this.actionGetPartners({name: this.filter.partner});
    }

    async onFilteredAction(nextPage = false) {
      if (!nextPage) this.filter.page_number = 1;
      try {
        this.logObject = {
          action_page: this.$route.meta.msgKey,
          action: "Viewing",
          action_status: "success",
          object_type: "Blacklist",
          addititional_info: getTranslatedParams(this.filter)
        }
        const resp = await this.actionGetBlacklists(this.filter)
        await this.actionLog(this.logObject);
        this.is_last = resp.length == 0;
      } catch (err) {
        await this.actionLog({...this.logObject, action_status: "failed"});
        notifyError(err);
      } finally {
        this.moreLoading = false;
      }
    }

    @Watch('filter.partner')
    onPartnerChanged(val?: string, oldVal?: string) {
      if ((oldVal && val !== oldVal) || !val) {
        this.unsetFilter('partner_user');
      }
    }

    @Watch('filter', {immediate: true, deep: true})
    onFilterChanged(val: BlacklistFilter) {
      this.filterParent = val;
    }

    @Watch('run')
    onRunFilter(val: boolean) {
      if (!val) return;
      this.filtered();
      this.run = false;
    }
  }
